import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { fuseAnimations } from '@fuse/animations';
import {
  Action,
  CuttingHistoryErrorLogDialogComponent,
  CuttingMaterial,
  CuttingTask,
  DataGridComponent,
  GridColDef,
  GridRowModel,
  GridValueGetterParams,
  StateCuttingTaskEnum,
} from 'cloud-shared-lib';

import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';
import { OrderDetailService } from '../order-detail.service';
import { LogMaterialsDialogComponent } from './log-materials-dialog/log-materials-dialog.component';

@Component({
  selector: 'cutting-cut-history',
  templateUrl: './cut-history.component.html',
  styleUrls: ['./cut-history.component.scss'],
  standalone: true,
  imports: [MatIconModule, DataGridComponent, AsyncPipe],
  animations: fuseAnimations,
})
export class CutHistoryComponent implements OnInit {
  @Input() materials: CuttingMaterial[];
  @Output() materialChanged: EventEmitter<CuttingMaterial[]> = new EventEmitter();
  logMaterialsDialogRef: MatDialogRef<LogMaterialsDialogComponent>;
  errorLogDialogRef: MatDialogRef<CuttingHistoryErrorLogDialogComponent>;

  data$: Observable<CuttingTask[]>;
  private datePipe = new DatePipe('ru');

  errorEnum: StateCuttingTaskEnum = StateCuttingTaskEnum.Error;

  columns: GridColDef[] = [
    {
      field: 'dateStart',
      headerName: $localize`Дата запуска`,
      valueFormatter: (dateStart: Date): string => this.datePipe.transform(dateStart, 'short'),
      cellClassName: 'justify-center',
      headerClassName: 'justify-center',
    },
    {
      field: 'dateFinish',
      headerName: $localize`Дата завершения`,
      valueFormatter: (dateFinish: Date): string => this.datePipe.transform(dateFinish, 'short'),
      cellClassName: 'justify-center',
      headerClassName: 'justify-center',
    },
    {
      field: 'stateCuttingTask',
      headerName: $localize`Статус`,
      headerClassName: 'justify-center',
      valueGetter: (params: GridValueGetterParams): string => {
        switch (params.row.stateCuttingTask) {
          case StateCuttingTaskEnum.Error:
            return $localize`Ошибка`;
          case StateCuttingTaskEnum.Success:
            return $localize`Успешно`;
          case StateCuttingTaskEnum.Wait:
            return $localize`В процессе`;
          default:
            return '';
        }
      },
      cellClassName: (row: GridRowModel): string => {
        if (row && row.stateCuttingTask !== undefined) {
          switch (row.stateCuttingTask) {
            case StateCuttingTaskEnum.Wait:
              return 'text-yellow-500 justify-center';
            case StateCuttingTaskEnum.Error:
              return 'text-red-500 justify-center';
            case StateCuttingTaskEnum.Success:
              return 'text-green-500 justify-center';
            default:
              return '';
          }
        }
      },
    },
    {
      field: 'usedPersonalCuttingSettings',
      headerName: $localize`Персональные настройки раскроя`,
      headerClassName: 'justify-center',
      cellClassName: 'justify-center',
      type: 'boolean',
      valueFormatter: (value: boolean): string => (value ? 'check_box' : 'check_box_outline_blank'),
    },
    {
      field: 'log',
      headerName: $localize`Описание`,
      headerClassName: 'justify-center',
      cellClassName: 'justify-center',
    },
    {
      field: 'materials',
      type: 'actions',
      headerName: $localize`Материалы`,
      headerClassName: 'justify-center',
      cellClassName: 'justify-center',
    },
  ];

  getActions = (row: CuttingTask): Action[] => {
    return [
      {
        icon: 'info_outline',
        showInMenu: false,
        label: '',
        onClick: (): void => {
          this.openMaterialsDialog(row.id);
        },
      },
    ];
  };

  constructor(private orderDetailService: OrderDetailService, private dialog: MatDialog, private injector: Injector) {}

  ngOnInit(): void {
    this.data$ = this.orderDetailService.getCutHistory();
  }

  openErrorLogDialog(error: string): void {
    const errorList = error.split('\n');

    this.errorLogDialogRef = this.dialog.open(CuttingHistoryErrorLogDialogComponent, {
      disableClose: false,
      width: '750px',
      data: errorList,
    });

    this.errorLogDialogRef.afterClosed().subscribe(() => {
      this.errorLogDialogRef = null;
    });
  }
  openMaterialsDialog(logId: number): void {
    const parentInjector = this.injector;

    this.logMaterialsDialogRef = this.dialog.open(LogMaterialsDialogComponent, {
      disableClose: false,
      panelClass: 'log-materials-dialog',
      maxWidth: '1500px',
      minWidth: '450px',
      injector: Injector.create({
        providers: [{ provide: OrderDetailService, useValue: parentInjector.get(OrderDetailService) }],
        parent: parentInjector,
      }),
    });

    this.logMaterialsDialogRef.componentInstance.logId = logId;
    this.logMaterialsDialogRef.componentInstance.materialsOrder = this.materials;

    this.logMaterialsDialogRef.afterClosed().subscribe((res: CuttingMaterial[]) => {
      if (res && res.length > 0) {
        this.materialChanged.emit(res);
      }
      this.logMaterialsDialogRef = null;
    });
  }
}
